var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-1 mt-n4"},_vm._l((_vm.sources),function(source,index){return _c('fuel-chip',{key:index,staticClass:"ml-2 mb-1",attrs:{"shortName":_vm.shortName,"value":source}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }